import { of } from 'rxjs'
import { EmiRequest } from 'models'
import Constants from 'api-constants'

// relation type for EPL game content
// it is not a part of `Constants.programType` so it was initialized here
export const EPL_GAME_RELATED_TYPE = 'eplGame'

export const getEmiRequestMapForVod = (program, platform) => {
    const id = getVodId(program, platform)

    if (program.isGame && program.isGame()) return getEmiRequestMapForGameVod(program, platform)

    return of({
        vod: new EmiRequest({
            value: Constants.customRequests.GET_RELATED_CONTENT,
            args: [
                {
                    relatedType: Constants.programType.vod,
                    contentType: Constants.programType.vod,
                    id,
                    program,
                },
            ],
            id: 'get_related_content_vod_from_vod_' + program.id,
            labels: { default: '' },
        }),
        // live: new EmiRequest({
        //     value: Constants.customRequests.GET_RELATED_CONTENT,
        //     args: [
        //         {
        //             relatedType: Constants.programType.live,
        //             contentType: Constants.programType.vod,
        //             id,
        //         },
        //     ],
        //     id: 'get_related_content_live_from_vod_' + program.id,
        //     labels: { default: '' },
        // }),
    })
}

export const getEmiRequestMapForLive = (program) => {
    if (program.isGame && program.isGame()) return getEmiRequestMapForGameLive(program)

    return of({
        // vod: new EmiRequest({
        //     value: Constants.customRequests.GET_RELATED_CONTENT,
        //     args: [
        //         {
        //             relatedType: Constants.programType.vod,
        //             contentType: Constants.programType.live,
        //             id: program.id,
        //         },
        //     ],
        //     id: 'get_related_content_vod_from_live_' + program.id,
        //     labels: { default: '' },
        // }),
        live: new EmiRequest({
            value: Constants.customRequests.GET_RELATED_CONTENT,
            args: [
                {
                    relatedType: Constants.programType.live,
                    contentType: Constants.programType.live,
                    id: program.id,
                },
            ],
            id: 'get_related_content_live_from_live_' + program.id,
            labels: { default: '' },
        }),
    })
}

const getEmiRequestMapForGameLive = (program) => {
    const competitionCode =
        program.optaDetails.optaCompetitionCode ||
        Constants.optaCompetitionCode.ENGLISH_PREMIER_LEAGUE
    return of({
        ...getEmiRequestMapForGame(program),
        vod: new EmiRequest({
            value: Constants.customRequests.GET_RELATED_CONTENT,
            args: [
                {
                    relatedType:
                        competitionCode === Constants.optaCompetitionCode.ENGLISH_PREMIER_LEAGUE
                            ? EPL_GAME_RELATED_TYPE
                            : Constants.programType.vod, // If no premier league recommendation, then use VOD reco for other type of game like World cup or bundesliga
                    contentType: Constants.programType.live,
                    id: program.id,
                    optaDetails: program.optaDetails || {},
                },
            ],
            id: 'get_related_content_vod_game_from_live_' + program.id,
            labels: { default: '' },
        }),
    })
}

const getEmiRequestMapForGameVod = (program, platform) => {
    const id = getVodId(program, platform)
    const competitionCode =
        program.optaDetails.optaCompetitionCode ||
        Constants.optaCompetitionCode.ENGLISH_PREMIER_LEAGUE
    return of({
        ...getEmiRequestMapForGame(program, platform),
        vod: new EmiRequest({
            value: Constants.customRequests.GET_RELATED_CONTENT,
            args: [
                {
                    relatedType:
                        competitionCode === Constants.optaCompetitionCode.ENGLISH_PREMIER_LEAGUE
                            ? EPL_GAME_RELATED_TYPE
                            : Constants.programType.vod, // If no premier league recommendation, then use VOD reco for other type of game like World cup or bundesliga
                    contentType: Constants.programType.vod,
                    id,
                    optaDetails: program.optaDetails || {},
                },
            ],
            id: 'get_related_content_vod_game_from_vod_' + program.id,
            labels: { default: '' },
        }),
    })
}

const getEmiRequestMapForGame = (program, platform) => {
    const id = getVodId(program, platform)
    const { optaSport = '', optaTeamId = '', optaCompetitionCode = '' } = program.optaDetails || {}
    return {
        previous_matches: new EmiRequest({
            value: Constants.emiRequests.GET_VODS_FROM_NODE_PLATFORM_ID,
            args: [
                {
                    id,
                    opta_sport: optaSport,
                    opta_team_id: optaTeamId,
                    opta_competition_code: optaCompetitionCode,
                    category: 'Matches',
                    content_type: 'episode,orphanEpisode',
                },
            ],
            options: {
                limit: 50,
            },
            id: 'get_related_content_previous_matches_from_vod_' + program.id,
            intlKey: {
                tag: 'previousMatchRecommendation',
            },
        }),
        matches_highlights: new EmiRequest({
            value: Constants.emiRequests.GET_VODS_FROM_NODE_PLATFORM_ID,
            args: [
                {
                    id,
                    opta_sport: optaSport,
                    opta_team_id: optaTeamId,
                    opta_competition_code: optaCompetitionCode,
                    category: ['Long Highlights', 'Short Highlights'],
                },
            ],
            options: {
                limit: 50,
            },
            id: 'get_related_content_matches_highlights_from_vod_' + program.id,
            intlKey: {
                tag: 'highlightRecommendation',
            },
        }),
    }
}

const getVodId = (program, platform) => {
    return (
        program.sourceId ||
        // Fallback in case of issue using a workaround
        `${program.id}${Constants.platform.ios === platform ? '_VERSION_HLS' : '_VERSION_DASH'}`
    ) // Shall not use program id
}
